import React, { useEffect, useRef } from "react";
import { connect, useDispatch } from "react-redux";
import { bool, func, shape } from "prop-types";
import { Field, Form, Formik } from "formik";
import * as i18nUtils from "util/i18n";
import { selectors as afipPaymentLinkSelectors, actions as afipPaymentLinkActions } from "reducers/afipPaymentLink";
import CustomText from "pages/_components/CustomText/CustomText";
import TextField from "pages/_components/fields/TextField";
import Button from "pages/_components/Button";
import I18n from "pages/_components/I18n";
import Image from "pages/_components/Image";
import moment from "moment";
import * as config from "util/config";
import { formatNum } from "util/format";

const FORM_ID = "vep.delete";

const DeleteVepForm = ({ handleClose, openForm, vep, handleListReload }) => {
    const dispatch = useDispatch();
    const formRef = useRef();

    useEffect(() => {
        if (!openForm) {
            formRef.current.resetForm();
        } else {
            const defaultTZ = config.get("administration.timezone.defaultValue", "America/Argentina/Buenos_Aires");

            const date = moment(vep?.expirationDate)
                .tz(defaultTZ)
                .format("DD/MM/YYYY");

            const currency = i18nUtils.get("currency.label.ARS");
            formRef.current.setFieldValue("id", vep?.id);
            formRef.current.setFieldValue("date", date);
            formRef.current.setFieldValue("cuil", vep?.cuitTaxpayer);
            formRef.current.setFieldValue("amount", `${currency} ${formatNum(vep?.amount, 2)}`);
        }
    }, [openForm]);

    const closeForm = () => {
        formRef.current.resetForm();
        handleClose();
        handleListReload();
    };

    const formikProps = {
        validateOnChange: true,
        validateOnBlur: false,
        initialValues: {
            id: "",
            date: "",
            cuil: "",
            amount: "",
        },
        onSubmit: (values) => {
            if (values) {
                const { id } = values;
                dispatch(afipPaymentLinkActions.deleteVep({ idVep: id }));
                closeForm();
            }
        },
    };

    return (
        <div className="container centered">
            <h1 className="title-content form-drawer-title">
                <CustomText text={i18nUtils.get("vep.delete.title", "Eliminar VEP")} />
            </h1>
            <Formik {...formikProps} ref={formRef}>
                {() => (
                    <Form>
                        <div className="form-drawer-content">
                            <div className="pb-6" />
                            <I18n
                                id="vep.delete.subtitle"
                                defaultValue={i18nUtils.get(
                                    "vep.delete.subtitle",
                                    "Estás por eliminar este VEP ¿Querés continuar?",
                                )}
                            />
                            <div className="pb-6" />
                            <Field
                                autoComplete="off"
                                component={TextField}
                                idForm={FORM_ID}
                                maxLength={50}
                                name="id"
                                labelTextDefault={i18nUtils.get("vep.delete.id", "Nº de Vep")}
                                hidePlaceholder
                                disabled
                            />
                            <Field
                                autoComplete="off"
                                component={TextField}
                                idForm={FORM_ID}
                                maxLength={50}
                                name="date"
                                labelTextDefault={i18nUtils.get("vep.delete.date", "Fecha de vencimiento")}
                                hidePlaceholder
                                disabled
                            />
                            <Field
                                autoComplete="off"
                                component={TextField}
                                idForm={FORM_ID}
                                maxLength={50}
                                name="cuil"
                                labelTextDefault={i18nUtils.get("vep.delete.cuil", "CUIT/CUIL contribuyente")}
                                hidePlaceholder
                                disabled
                            />
                            <Field
                                autoComplete="off"
                                component={TextField}
                                idForm={FORM_ID}
                                maxLength={50}
                                name="amount"
                                labelTextDefault={i18nUtils.get("vep.delete.amount", "Monto")}
                                hidePlaceholder
                                disabled
                            />
                            <div className="box info service-payments__no-data">
                                <Image src="images/information_fill.svg" />{" "}
                                <I18n
                                    id="vep.delete.disclaimer"
                                    defaultValue="Recordá que al eliminar el VEP, dejarás de visualizar en tu  Online Banking, pero continuará disponible en el portal de ARCA."
                                />
                            </div>
                            <div className="pb-6" />
                            <Button type="submit" bsStyle="primary" label="global.delete" loading={false} block />
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

DeleteVepForm.propTypes = {
    isDesktop: bool.isRequired,
    fetching: bool.isRequired,
    handleClose: func.isRequired,
    openForm: bool.isRequired,
    handleFetchData: func.isRequired,
    vep: shape({}).isRequired,
    handleListReload: func.isRequired,
};

DeleteVepForm.defaultProps = {};

const mapStateToProps = (state) => ({
    vepsFilters: afipPaymentLinkSelectors.getFilters(state),
});

export default connect(mapStateToProps)(DeleteVepForm);
